export default __webpack_public_path__ + "static/media/sun_icon.f99b9fa1.png";